export default function Privacy() {
  return (
    <div style={{
      minHeight: '100vh',
      padding: '2.5rem 1.5rem',
      backgroundColor: '#0b0b0b',
      color: '#f5f5f5',
      lineHeight: 1.6,
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
    }}>
      <main style={{
        maxWidth: '840px',
        margin: '0 auto',
        background: '#151515',
        borderRadius: '16px',
        padding: '2.5rem',
        border: '1px solid #1f1f1f',
        boxShadow: '0 24px 48px rgba(0, 0, 0, 0.45)'
      }}>
        <h1 style={{ color: '#c4ff00', fontWeight: 600, marginTop: 0 }}>Privacy Policy</h1>
        <p><strong>Last updated:</strong> January 2025</p>

        <p>Ember is a private beta for pipe and cigar enthusiasts. This policy explains what information we collect and how it is used while you access <em>https://ember-app.online</em> and our mobile or desktop experiences.</p>

        <h2 style={{ color: '#c4ff00', fontWeight: 600 }}>Age Requirement</h2>
        <p>Ember is intended only for adults who are of legal smoking age in their country. By creating an account, you confirm you meet that requirement.</p>

        <h2 style={{ color: '#c4ff00', fontWeight: 600 }}>Information We Collect</h2>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li><strong>Account data:</strong> Email address, username, and profile details you provide.</li>
          <li><strong>Activity data:</strong> Cellar entries, check-ins, sessions, photos, and event participation you record.</li>
          <li><strong>Technical data:</strong> Limited analytics such as device type and session logs to keep Ember reliable.</li>
        </ul>

        <h2 style={{ color: '#c4ff00', fontWeight: 600 }}>How We Use Your Information</h2>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li>Provide, maintain, and improve the Ember application.</li>
          <li>Sync your data across devices using Supabase (authentication, database, and storage services).</li>
          <li>Send account notifications you enable (for example, reminders or event updates).</li>
        </ul>

        <h2 style={{ color: '#c4ff00', fontWeight: 600 }}>Data Hosting & Security</h2>
        <p>Ember stores user accounts, cellar data, and media in Supabase, which provides managed PostgreSQL, authentication, and storage. Supabase encrypts data in transit and at rest. Only the Ember development team has access to project administration tools.</p>

        <h2 style={{ color: '#c4ff00', fontWeight: 600 }}>Sharing & Disclosure</h2>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li>We do not sell or broker personal data.</li>
          <li>Public profile or cellar items you mark as shared may be visible to other Ember users.</li>
          <li>We may disclose information if legally required or to enforce our Terms of Use.</li>
        </ul>

        <h2 style={{ color: '#c4ff00', fontWeight: 600 }}>Data Retention & Deletion</h2>
        <p>We keep your account information while you maintain an Ember account. You may request deletion of your account and all related data at any time by emailing <a href="mailto:privacy@ember-app.online" style={{ color: '#d3de5e' }}>privacy@ember-app.online</a>.</p>

        <h2 style={{ color: '#c4ff00', fontWeight: 600 }}>Third-Party Services</h2>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li><strong>Supabase:</strong> Authentication, database, and file storage.</li>
          <li><strong>Sentry / analytics:</strong> Error reporting and limited usage metrics to improve stability.</li>
        </ul>

        <h2 style={{ color: '#c4ff00', fontWeight: 600 }}>Your Choices</h2>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li>Update profile or notification settings inside the Ember app.</li>
          <li>Disable cookies at the browser level (may affect functionality).</li>
          <li>Request account deletion via <a href="mailto:privacy@ember-app.online" style={{ color: '#d3de5e' }}>privacy@ember-app.online</a>.</li>
        </ul>

        <h2 style={{ color: '#c4ff00', fontWeight: 600 }}>Contact</h2>
        <p>If you have any questions about this policy or need assistance, email <a href="mailto:privacy@ember-app.online" style={{ color: '#d3de5e' }}>privacy@ember-app.online</a>.</p>
      </main>
    </div>
  );
}

